// Pricing configuration
export const pricing = {
  ghosthub: {
    price: 199,
    version: "2.0",
    shipping: "shipping",
    currency: "$"
  },
  competitors: {
    plex: {
      lifetime: 249.99,
      monthly: 6.99
    },
    jellyfin: {
      price: 0
    }
  }
};

export default pricing;
